<template>
  <router-link
    v-if="isVisible"
    :to="to"
  >
    <slot></slot>
  </router-link>
</template>

<script>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { canAccessRoute } from '@/utils/routeAccess'

export default {
  name: 'ConditionalRouterLink',
  props: {
    to: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const router = useRouter()

    const isVisible = computed(() => canAccessRoute(props.to, router))

    return {
      isVisible
    }
  }
}
</script>
